import { render, staticRenderFns } from "./Notifications-modal.vue?vue&type=template&id=f70316e4&scoped=true"
import script from "./Notifications-modal.vue?vue&type=script&lang=js"
export * from "./Notifications-modal.vue?vue&type=script&lang=js"
import style0 from "./Notifications-modal.vue?vue&type=style&index=0&id=f70316e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70316e4",
  null
  
)

export default component.exports